import React from "react";

import { RequestContext, UseRequest } from "shared/providers/RequestProvider";

export const useRequestContext = (): UseRequest => React.useContext(RequestContext);
